import { handleActions } from 'redux-actions'
import { setOnSuccess } from 'lp-redux-api'
import { selectorForSlice } from 'lp-redux-utils'
import * as apiActions from 'api-actions'

const reducerKey = 'surveyArchive'
const slice = 'root.schoolPortal.surveyArchive'

const initialState = {}

const reducer = handleActions(
  {
    [apiActions.fetchSurveyArchives]: setOnSuccess('archives'),
  },
  initialState
)

const select = selectorForSlice(slice)

const selectors = {
  archives: select('archives'),
}

export { reducer, selectors, reducerKey }
